<template>
  <span :class="{ 'd-flex align-items-center': !inline }">
    <slot />
    <HelpReference
      v-if="isStaff && is_help_reference_enabled"
      :identifier="identifier"
      :class="{ 'd-flex align-items-center': !inline }"
    />
  </span>
</template>

<script>
import { mapGetters, mapState } from "vuex";
// Lazy load the component to exclude it from parent bundle.
const HelpReference = () =>
  import(/* webpackChunkName: "help-reference" */ "./HelpReference.vue");

export default {
  components: { HelpReference },
  props: {
    identifier: {
      type: String,
      required: true,
    },
    inline: Boolean,
  },
  computed: {
    ...mapGetters(["isStaff"]),
    ...mapState("staffStore", ["is_help_reference_enabled"]),
  },
};
</script>
